/**
 * Interactive twitter icon which loads content and opens tweet page
 */
import { useCallback, useState } from "react";
import axios from 'axios';

interface itwitterprops {
    exchange: string | undefined;
    authToken: string;
}

enum twistate {
    normal,
    loading,
}

/**
 * TODO: Move to frontend-common
 * @returns 
 */
const fetchTwitterContent = async () => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/cex/v1/content?network=twitter&type=post`;
        const data = await axios.get(url);
        return data.data?.content;
    } catch (e) {
        console.error("can't load twitter content", e);
        return null;
    }
};

const UseTwitter = ({ exchange, authToken }: itwitterprops) => {
    const [state, setState] = useState<twistate>(twistate.normal);

    const onTwitterShare = useCallback(() => {
        if (state != twistate.loading) {
            setState(twistate.loading);
            fetchTwitterContent().then((twittText) => {
                window.open(`https://twitter.com/intent/tweet?text=${twittText}`);
                setState(twistate.normal);
            }).catch(() => {
                setState(twistate.normal);
            });
        }
    }, [exchange, authToken]);

    switch (state) {
        case twistate.loading:
            return (<div
                className='points__body__item__icon points__body__item__icon--twitter icon-twitter points__body__item__icon--loading'
            />);
        default:
            return (<div
                className='points__body__item__icon points__body__item__icon--twitter icon-twitter points__body__item__icon--clickable'
                onClick={onTwitterShare}
            />);
    }
};

export default UseTwitter;